exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-fda86dc4] .el-card__body{height:100%;padding:10px}", ""]);

// exports
